import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="item"
export default class extends Controller {
  static targets = ["link"] // Stimulus 타겟을 지정

  connect() {
    // 모든 item_id 필드를 찾아서 인덱스를 추출
    const itemFields = document.querySelectorAll('[name^="order[order_infos_attributes]"][name$="[item_id]"]')
    if (itemFields.length > 0) {
      // 마지막 아이템의 인덱스 값을 가져와서 그 다음 순번으로 설정
      const lastIndex = Array.from(itemFields).map(field => {
        const match = field.name.match(/\[order_infos_attributes\]\[(\d+)\]/)
        return match ? parseInt(match[1]) : 0
      }).sort((a, b) => b - a)[0] // 가장 큰 인덱스를 찾음
      this.itemNumber = lastIndex + 1 // 다음 아이템 인덱스
    } else {
      this.itemNumber = 0 // 그려진 아이템이 없을 경우 0부터 시작
    }
  }

  addItem() {
    // link target 사용해 링크를 참조
    const link = this.linkTarget
    const baseHref = link.dataset.baseHref || link.getAttribute('href')
    link.dataset.baseHref = baseHref // baseHref 저장
    const newHref = `${baseHref}?item_number=${this.itemNumber}`
    link.setAttribute('href', newHref)

    this.itemNumber++ // 클릭할 때마다 순번 증가
  }

  removeItem(event) {
    event.preventDefault()
    const row = event.target.closest('tr')
    if (row) {
      row.remove()
    }
  }

  selectItem(event) {
    event.preventDefault()

    const itemNumber = event.currentTarget.getAttribute('data-item-number')
    const itemName = event.currentTarget.getAttribute('data-item-name')
    const itemID = event.currentTarget.getAttribute('data-item-id')
    const itemBarcode = event.currentTarget.getAttribute('data-item-barcode')
    const itemNickName = event.currentTarget.getAttribute('data-item-nick-name')

    const targetFrame = document.getElementById(`item-number-${itemNumber}`)

    if (targetFrame) {
      let icon = targetFrame.querySelector('i')
      if (!icon) {
        icon = document.createElement('i')
        icon.className = 'fa-solid fa-magnifying-glass'
        targetFrame.prepend(icon)
      }

      const textSpan = targetFrame.querySelector('span') || document.createElement('span')
      textSpan.textContent = itemName
      if (!textSpan.parentNode) targetFrame.appendChild(textSpan)
      textSpan.classList.add('text-gray-900')

      targetFrame.classList.add('btn-edit')

      if (itemBarcode === "true") {
        const barcodeContainer = document.getElementById(`order_order_infos_attributes_${itemNumber}_barcode`)
        if (barcodeContainer) {
          barcodeContainer.removeAttribute('disabled')
          barcodeContainer.classList.remove('disabled')
        }
      }
    }

    const hiddenInput = document.getElementById(`order_order_infos_attributes_${itemNumber}_item_id`)

    if (hiddenInput) {
      hiddenInput.value = itemID
    }

    if (itemNickName) {
      const nickNameInput = document.getElementById(`order_order_infos_attributes_${itemNumber}_nick_name`)

      if (nickNameInput) {
        nickNameInput.value = itemNickName
      }
    }

    const closeEvent = new CustomEvent('modals:close', {bubbles: true})
    window.dispatchEvent(closeEvent)
  }
}
